import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './AccountInfo.css';

import { useDispatch, useSelector } from 'react-redux';
import { accountsLoading, loadAccountsByUser, selectAccounts } from '../../features/manageAccounts/accountsSlice';
import { isLoggedIn } from '../../features/login/loginSlice';

import Sidebar from '../sidebar/Sidebar';
import { selectUser } from '../../features/home/userSlice';

export default function AccountInfo() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const accounts = useSelector(selectAccounts)
    const loadingAccounts = useSelector(accountsLoading);
    const loggedIn = useSelector(isLoggedIn);

    const userInfo = useSelector(selectUser);
    const username = userInfo.username

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        if (Object.values(accounts).length < 1 && username) {
            dispatch(loadAccountsByUser(username))
        }
    })

    return (
        <main>
            <Sidebar />
            <section className='account-info'>
                <h2>Account Info</h2>
                <h3>Account Numbers</h3>
                {loadingAccounts ? <h3>Loading Account Information...</h3> : Object.values(accounts).map(account => {
                    return (
                        <article key={account.accountId}>
                            <h4>{account.accountType}</h4>
                            <div className='flex-container'>
                                <div className='flex-item'>
                                    <h6>Account Number</h6>
                                    <h5>{account.accountId}</h5>
                                </div>
                                <div className='flex-item'>
                                    <h6>Routing Number</h6>
                                    <h5>987654321</h5>
                                </div>
                            </div>
                        </article>
                    )
                })}
            </section>
        </main>
    )
}